import { createApi } from '@reduxjs/toolkit/query/react';

import { Resource } from 'types';
import { URL } from 'api/constants';

import { apiQuery } from '../../query';
import { invalidateCourseStepCaches } from '../course-steps/invalidation-helpers';

import { CreateRequest, ResourceResponse } from './types';

const tagTypes = ['RESOURCES'];

export const resourcesApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'resourcesApi',
  endpoints: (build) => ({
    create: build.mutation<Resource, CreateRequest>({
      invalidatesTags: tagTypes,
      transformResponse: (response: ResourceResponse) => response.data,
      onQueryStarted: ({ courseStepId }, api) =>
        invalidateCourseStepCaches(courseStepId, api),
      query: (data) => ({
        data,
        method: 'post',
        url: URL.RESOURCES_LIST,
      }),
    }),
  }),
});

export const { useCreateMutation } = resourcesApi;

export type { CreateRequest };
